module.exports = __webpack_public_path__ + "img/Historia03.dc0ea0f9.jpg";